import React from 'react';

const StatisticItem = ({ name, coefficient }) => {
  return (
    <div className='cards-content'>
      <div className={`cards-content-img ${name}`} />
      <div className='cards-content-symbol'>
        <span className='c-c-s-num'>{coefficient}</span>
      </div>
    </div>
  );
};

export { StatisticItem };
